export default __webpack_public_path__ + "static/ogg-roman-9bdae92b1fdc273f60ec931675b4515a.woff2";